// AXIOS
import axios from "axios";

// api url
import { apiToken, apiUrl_forCustomers } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get admin users
export let cancelcheckEmailExistenceApi;
export async function checkEmailExistence(email) {
    if (email) {
        const users = await axios.get(
            apiUrl_forCustomers + "/email/exist?email=" + email,
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelcheckEmailExistenceApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// add customer
export let cancelAddCustomerApi;
export async function addCustomer(token, customerData) {
    if (customerData) {
        const customers = await axios.post(
            apiUrl_forCustomers + "/",
            customerData,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelUpdateCustomerApi;
export async function updateCustomer(token, customerData) {
    if (token && customerData) {
        const customers = await axios.put(
            apiUrl_forCustomers + "/" + customerData.user_id,
            customerData,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please update required parameters");
    }
}

// update customer's password
export let cancelUpdateCustomersPasswordApi;
export async function updateCustomersPassword(token, customerData) {
    if (token && customerData) {
        const customers = await axios.put(
            apiUrl_forCustomers + "/password/" + customerData.user_id,
            {
                // old_password: customerData.oldPassword,
                password: customerData.newPassword,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateCustomersPasswordApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please update required parameters");
    }
}

// get customerCountries
export let cancelGetCustomerCountries;
export async function getCustomerCountries() {
    const customerCountries = await axios.get(
        apiUrl_forCustomers + "/countries",
        {
            headers: {
                "Api-Token": apiToken,
                "Access-Token": "",
            },
        },
        {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomerCountries = c;
            }),
        }
    );
    return customerCountries;
}

// get customerStates
export let cancelGetCustomerStates;
export async function getCustomerStates(country_id) {
    const customerStates = await axios.get(
        apiUrl_forCustomers + "/state/country/" + country_id,
        {
            headers: {
                "Api-Token": apiToken,
                "Access-Token": "",
            },
        },
        {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomerStates = c;
            }),
        }
    );
    return customerStates;
}

// get customerCities
export let cancelGetCustomerCities;
export async function getCustomerCities(region_id) {
    const customerCities = await axios.get(
        apiUrl_forCustomers + "/city/state/" + region_id,
        {
            headers: {
                "Api-Token": apiToken,
                "Access-Token": "",
            },
        },
        {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetCustomerCities = c;
            }),
        }
    );
    return customerCities;
}

// add customer address
export let cancelAddCustomerAddressApi;
export async function addCustomerAddress(token, addressData) {
    if (addressData) {
        const customerAddress = await axios.post(
            apiUrl_forCustomers + "/address/" + addressData.user_id,
            addressData,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerAddressApi = c;
                }),
            }
        );
        return customerAddress;
    } else {
        console.log("Please add required parameters");
    }
}

// get CustomerAddresses
export let cancelGetCustomerAddessesApi;
export async function getCustomerAddresses(token, customerId) {
    if (customerId) {
        const customerAddresses = await axios.get(
            apiUrl_forCustomers + "/addresses/" + customerId,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerAddessesApi = c;
                }),
            }
        );
        return customerAddresses;
    } else {
        console.log("Please add required parameters");
    }
}

// send reset password email
export let cancelSendResetPasswordApi;
export async function sendResetPassword(token, email) {
    if (email) {
        const users = await axios.post(
            apiUrl_forCustomers + "/send/reset/password",
            {
                email,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSendResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// send reset password email
export let cancelValidateResetPasswordApi;
export async function validateResetPassword(token, { userId, userToken }) {
    if (userId && userToken) {
        const users = await axios.get(
            apiUrl_forCustomers + `/reset/password/${userId}/${userToken}`,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelValidateResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// reset password
export let cancelResetPasswordApi;
export async function resetPassword(token, { userId, userToken, password }) {
    if (userId && userToken) {
        const users = await axios.post(
            apiUrl_forCustomers + `/reset/password/${userId}/${userToken}`,
            {
                password,
                confirm_password: password,
            },
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelResetPasswordApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// get customer detail
export let cancelGetCustomerDetailsApi;
export async function getCustomerDetails(token, cutomerId) {
    if (token && cutomerId) {
        const customers = await axios.get(
            apiUrl_forCustomers + "/" + cutomerId,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerDetailsApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}
